<template>
  <div class="wisdom-subject main">
      <div class="sort-navigate flex-layout">
          <span class="sort-name">{{map[proId].typeName}}：</span>
          <ul class="sort-ul">
            <li v-for="(item,index) in navigate" 
                :key="index"
                :class="{'active':active === index}"
                @click="handleClick(item,index)"
                class="sort-item csp">
                {{item.name}}
            </li>
          </ul>
          <div class="sort-search">
            <el-input
              size="mini"
              placeholder="请输入课程名称"
              suffix-icon="el-icon-search"
              v-model="search"
              @change="searchCourse">
            </el-input>
          </div>
      </div>
      <div  v-if="courseList.length > 0 && courseList">
        <div class="course-part flex-layout">
          <div class="card csp" v-for="(item,index) in courseList" :key="index" @click="toDetail(item,index)">
              <img :src="downloadURL + item.cover" alt="" class="course-cover" :onerror="defualtImage[Math.floor(Math.random() * 5)]" >
              <h4 class="course-name wes-2">{{item.name || '--'}}</h4>
              <div class="summary flex-align-between">
                <!-- <p class="time">
                  {{handleTime(item.timeScope) || '--'}}
                </p> -->
                <div class="info flex-align">
                  <img :src="downloadURL + item.avatar" alt="" class="tea-avatar" :onerror="defualtAvatar">
                  <span class="tea-name">{{item.teacherName || '--'}}</span>
                </div>
                <span class="time"> {{handleTime(item.timeScope) || '--'}}</span>
              </div>
          </div>
        </div>
        <div class="pagination-part">
          <pagination v-show="pages.total > 0" 
                      :total="pages.total" 
                      :page.sync="pages.currentPage" 
                      :limit.sync="pages.pageSize"
                      :background="true"
                      @pagination="handlePageChange">
          </pagination>
        </div>
      </div>
      <!-- 无课节-->
      <div class="nothing-box flex-align" v-else>
        <div class="nothing-wrap">
          <img src="@/assets/wisdom/nothing.png" alt="">
          <p>暂无内容</p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props:{
    columnId:{
      type:Number
    }
  },
  data() {
    return {
      proId:Number(sessionStorage.getItem('projectID')),
      navigate:[], //分类导航
      search:'', //搜索课程
      active:0, //当前被选中的导航
      currentTabId:null, //当前被选中的选项卡Id
      courseList:[], //课程列表
      pages:{ //分页
        currentPage: 1,
        pageSize:8,
        total:100,
      },
      map:{ //根据项目ID获取数据的Map
        90:{
          typeName:'学科',
          paramsName:'subjectId'
        },
        109:{
          typeName:'课程类型',
          paramsName:'specialtyId'
        },
        110:{
          typeName:'课程类型',
          paramsName:'openTypeId'
        }
      },
      defualtAvatar:'this.src="' + require("../../../assets/wisdom/men.png") + '"', //默认头像
      defualtImage: [ //课程默认封面
          'this.src="' + require("../../../assets/wisdom/course-cover01.jpg") + '"',
          'this.src="' + require("../../../assets/wisdom/course-cover02.jpg") + '"',
          'this.src="' + require("../../../assets/wisdom/course-cover03.jpg") + '"',
          'this.src="' + require("../../../assets/wisdom/course-cover04.jpg") + '"',
          'this.src="' + require("../../../assets/wisdom/course-cover05.jpg") + '"',
      ],
      
    }
  },
  watch: {
    columnId: {
      handler(newVal,oldVal) {
        if(!newVal) return
        this.getCourseList()
      },
      // immediate: true
    }
  },
  methods: {
    // 切换学科
    handleClick(item,index) {
      this.active = index;
      this.currentTabId = item.id;
      this.pages.currentPage = 1
      this.getCourseList();
    },
    // 切换分页
    handlePageChange(data){
      this.pages.currentPage = data.pageIndex
      this.pages.pageSize = data.pageSize
      this.getCourseList();
    },
     // 处理时间格式
    handleTime(time){
      if(!time) return
      time = time.split('~')
      time = time[0].split(' ')
      time = time[0].split('.').join('-')
      return time;
    },
    // 搜索课程
    searchCourse(val){
      console.log(val);
      this.pages.currentPage = 1
      this.getCourseList();
    },
    // 去课程详情页
    toDetail(item,index) {
      this.$router.push(`/yunqiao/subject/detail/${item.id}`)
    },
    // 根据不同项目获取不同选项卡
    async getTabsList() {
      let resData;
      if(this.proId === 90) {
        resData = await Api.Wisdom.getSubjectList()
      } else if (this.proId === 109) {
        resData = await Api.Wisdom.getSpecialtyList()
      } else if (this.proId === 110) {
        resData = await Api.Wisdom.getCourseType();
      }
      // console.log(resData);
      this.navigate = resData.data
      this.navigate.unshift({
         id: null,
         name: "全部"
       })
      this.getCourseList();
    },
    // 获取课程列表
    async getCourseList() {
      if(!this.columnId) return
      let xParamsName = this.map[this.proId].paramsName
      // console.log(xParamsName);
      let params = {
        page: this.pages.currentPage,
        limit: this.pages.pageSize,
        columnId:this.columnId,
        projectId: Number(sessionStorage.getItem('projectID'))
      }
      params[xParamsName] =  this.currentTabId,
      params.name = this.search ? this.search : null;
       let resData = await Api.Wisdom.getCourseList(params)
       console.log(resData);
       if(!resData.data) return;
       this.courseList = resData.data.list;
       this.pages.total = resData.data.totalCount;
    },
  },
  mounted() {
    this.getTabsList();
  },
}
</script>

<style lang="less" scoped>
  @import "./less/wisdom_subject.less";
</style>